import PropTypes from "prop-types";
import React from "react";
import themeGet from "@styled-system/theme-get";
import styled from "styled-components";

import { useHeaderSearchRecentsContext } from "src/components/Search/headerSearch/HeaderSearchRecentsContext";
import { isBlankHeaderSearchTerm } from "src/components/Search/headerSearch/headerSearchRecentEntries";

export const StyledMenu = styled.div`
  background-color: ${(props) => themeGet("colors.surfaceRaised")(props)};
  border-radius: ${(props) => themeGet("radii.2")(props)};
  margin: ${(props) => themeGet("space.s")(props)} 0;
  box-shadow:
    0 0 0 1px hsla(0, 0%, 0%, 0.1),
    0 4px 11px hsla(0, 0%, 0%, 0.1);
  z-index: 1;
  box-sizing: border-box;
  width: calc(100vw - 32px);
  left: 16px;
  position: fixed;
  /* Dynamic position under search bar when menuTop is measured */
  top: ${(props) =>
    props.$menuTop != null
      ? `${props.$menuTop}px`
      : `calc(${themeGet("appScale.navBarSize")(props) || "48px"} + 88px)`};
  overflow: hidden;

  @media screen and (min-width: 700px) {
    width: 100%;
    position: absolute;
    left: 0;
    top: 100%;
  }
`;

const Menu = ({ innerRef, innerProps, children, selectProps }) => {
  const { menuTop, isForSearchPage, headerSearchTerm } = selectProps;
  const headerSearch = useHeaderSearchRecentsContext();
  const hideEmptyRecents =
    Boolean(headerSearch) &&
    !isForSearchPage &&
    isBlankHeaderSearchTerm(headerSearchTerm) &&
    (headerSearch.loading || headerSearch.targets.length === 0);

  if (isForSearchPage || hideEmptyRecents) {
    return null;
  }

  return (
    <StyledMenu ref={innerRef} {...innerProps} $menuTop={menuTop}>
      {children}
    </StyledMenu>
  );
};

Menu.propTypes = {
  innerProps: PropTypes.object,
  innerRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.string,
  ]),
  children: PropTypes.node,
  selectProps: PropTypes.object,
};

export default Menu;
